import Text from 'components/Formik/Text';

const Address = ({ initialValues, label = 'Address' }) => {
	initialValues.Address = '';
	return <Text label={label} name='Address' type='text' />;
};

export default Address;
